import { LABO_ISLANDS } from "./laboRegistry";
import { mountIslands, whenIdle } from "./mount";

whenIdle(() => mountIslands(LABO_ISLANDS));
